module.exports = __webpack_public_path__ + "img/1480997091.a311e3f1.jpg";